import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Modal from 'reboron/DropModal'
import { push } from 'react-router-redux'

import Activity from './section/Activity'
import BasicInformation from './section/BasicInformation'
import Comments from './Comments'
import Images from './section/Images'
import ModalComponent from '../mini/ModalComponent'
import NoActivities from './section/NoActivities'
import OtherInformation from './section/OtherInformation'
import QuestHistory from './section/QuestHistory'
import QuestReview from './section/QuestReview'
import Skills from './section/Skills'
import StudentStats from './studentstats/StudentStats'
import Topics from './section/Topics'
import MultipleEditorsInfo from './multipleeditors/MultipleEditorsInfo'
import { ButtonErrorText } from './_Styled'
import Display from '../typography/Display'

import {
  editQuestDetails,
  editQuestMentorNote,
  deleteNote,
  createQuestMentorNote,
  startEditQuest,
  cancelEditQuest,
  deleteQuest,
  editQuestDetailsFailure
} from '../../actions/quest'
import { postLoggingInfo } from '../../actions/logging'
import {
  complete,
  incomplete,
  save,
  cancel,
  basicInformation,
  topicsAndStandards,
  imagesMessage,
  activitiesMessage,
  otherInformation,
  internalReview,
  nameCantBeBlank
} from '../../utils/messages'
import { messages as alertMessages } from '../../utils/messages/alert'
import {
  filterCurrentUserFromMembers,
  formatModalWarningMessageProp
} from '../../utils/multipleeditors'
import {
  unsubscribeFromAllChannelsWithPrefix,
  hasNeededPusherConnection
} from '../../utils/pusher'
import { questIsInDraftState } from '../../utils/review'
import { getTruncatedString } from '../../utils/string'
import { getDefaultRoute } from '../../utils/routes'
import {
  isOtherInformationComplete,
  isBasicInformationComplete,
  areActivitiesComplete,
  areImagesComplete,
  hideQuestComments
} from '../../utils/quest'
import {
  isQuestCopyEditorOrQuestAuthorOrQuestManager,
  isQuestAuthor,
  isQuestManager
} from '../../utils/user'
import { parseErrors, getErrorCount } from '../../utils/error'
import { contentWarningsSelectedButNoValues } from '../../utils/contentwarnings'

class Body extends Component {
  constructor(props) {
    super(props)
    this.state = {
      quest: props.quest,
      notes: props.notes[0]
        ? {
            file: props.notes[0],
            description: props.notes[0].description
          }
        : '',
      presenceChannelModalMessage: {},
      newEditors: []
    }

    this.onEditClickBound = this.onEditClick.bind(this)
    this.onActualEditClickBound = this.onActualEditClick.bind(this)
    this.onCancelEditClickBound = this.onCancelEditClick.bind(this)
    this.onSaveEditClickBound = this.onSaveEditClick.bind(this)
    this.handleChangeBound = this.handleChange.bind(this)
    this.handleNotesUploadBound = this.handleNotesUpload.bind(this)
    this.handleNotesDescriptionChangeBound =
      this.handleNotesDescriptionChange.bind(this)
    this.handleDeleteNoteBound = this.handleDeleteNote.bind(this)
    this.onCloseModalClickBound = this.onCloseModalClick.bind(this)
    this.handleNotesUploadCancelBound = this.handleNotesUploadCancel.bind(this)
    this.onDeleteQuestClickBound = this.onDeleteQuestClick.bind(this)
    this.onActualDeleteQuestClickBound =
      this.onActualDeleteQuestClick.bind(this)
    this.hideModalBound = this.hideModal.bind(this)
    this.checkMultipleEditorsBound = this.checkMultipleEditors.bind(this)
    this.editorAddedBound = this.editorAdded.bind(this)
    this.confirmMultipleUsersEditBound =
      this.confirmMultipleUsersEdit.bind(this)
    this.cancelMultipleUsersEditBound = this.cancelMultipleUsersEdit.bind(this)
  }

  componentDidMount() {
    this.props.dispatch(cancelEditQuest())
    this.editQuestErrorModal = this.refs.editQuestErrorModal
    this.deleteQuestModal = this.refs.deleteQuestModal.refs.modal
    this.multipleEditorsWarningModal =
      this.refs.multipleEditorsWarningModal.refs.modal
  }

  componentWillUnmount() {
    if (window.oeQMQuestPusherInstance) {
      unsubscribeFromAllChannelsWithPrefix(
        window.oeQMQuestPusherInstance,
        'presence-quest'
      )
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.section !== this.props.section) {
      this.setState(() => ({
        quest: nextProps.quest
      }))
    }
  }

  render() {
    const {
      quest,
      analytics,
      dispatch,
      topicSearchResults,
      isSearchingTopics,
      user,
      organization,
      isSavingQuest,
      error,
      activities
    } = this.props

    var section, sectionHeader
    var isSectionComplete = false
    const selectedSubsection = this.props.subsection
    const displayCompleteness =
      this.props.section === 'basicinformation' ||
      this.props.section === 'activities' ||
      this.props.section === 'images' ||
      this.props.section === 'otherinformation'
    const allowEdit =
      questIsInDraftState(quest) &&
      isQuestCopyEditorOrQuestAuthorOrQuestManager(user, quest, organization)

    const displayStartEdit =
      allowEdit &&
      !this.props.isEditingQuest &&
      (this.props.section === 'basicinformation' ||
        this.props.section === 'otherinformation')
    const displayFinishEdit =
      allowEdit &&
      this.props.isEditingQuest &&
      (this.props.section === 'basicinformation' ||
        this.props.section === 'otherinformation')

    const displayDeleteQuest =
      allowEdit &&
      this.props.isEditingQuest &&
      this.props.section === 'basicinformation' &&
      (isQuestAuthor(user, quest, organization) || isQuestManager(user))

    switch (this.props.section) {
      case 'basicinformation':
        isSectionComplete = isBasicInformationComplete(quest)
        sectionHeader = basicInformation
        section = (
          <BasicInformation
            quest={quest}
            handleChange={this.handleChangeBound}
            handleNotesUpload={this.handleNotesUploadBound}
            handleNotesDescriptionChange={
              this.handleNotesDescriptionChangeBound
            }
            deleteNote={this.handleDeleteNoteBound}
            dispatch={dispatch}
            handleNotesUploadCancel={this.handleNotesUploadCancelBound}
          />
        )
        break

      case 'skills':
        sectionHeader = 'Skills'
        section = <Skills allowEdit={allowEdit} />
        break

      case 'topicsandstandards':
        sectionHeader = topicsAndStandards
        section = (
          <Topics
            quest={quest}
            topics={this.props.topics}
            questId={quest.id}
            dispatch={dispatch}
            topicSearchResults={topicSearchResults}
            isSearching={isSearchingTopics}
            allowEdit={allowEdit}
          />
        )
        break

      case 'activities':
        isSectionComplete = areActivitiesComplete(activities)
        sectionHeader = activitiesMessage
        // If there are no activities, don't use the Activity component.
        // By default, it will try to dispatch and load data that it cannot.
        section =
          activities.length > 0 ? (
            <Activity
              quest={quest}
              activityId={this.props.activityId}
              allowEdit={allowEdit}
            />
          ) : (
            <NoActivities
              quest={quest}
              dispatch={dispatch}
              allowEdit={allowEdit}
            />
          )
        break

      case 'images':
        isSectionComplete = areImagesComplete(quest)
        sectionHeader = 'Image'
        section = (
          <Images
            quest={quest}
            allowEdit={allowEdit}
            handleChange={this.handleChangeBound}
            dispatch={dispatch}
            isSavingQuest={isSavingQuest}
          />
        )
        break

      case 'otherinformation':
        isSectionComplete = isOtherInformationComplete(quest)
        sectionHeader = otherInformation
        section = (
          <OtherInformation
            quest={quest}
            handleChange={this.handleChangeBound}
            isEditingQuest={this.props.isEditingQuest}
            dispatch={dispatch}
            tags={this.props.tags}
          />
        )
        break

      case 'questreview':
        sectionHeader = internalReview
        section = (
          <QuestReview handleAssignClick={this.props.handleAssignClick} />
        )
        break

      case 'questhistory':
        sectionHeader = 'Quest History'
        section = <QuestHistory />
        break
    }

    if (selectedSubsection) {
      setTimeout(function () {
        document
          .getElementById(`section-${selectedSubsection}`)
          .scrollIntoView()
      }, 300)
    }

    const questSectionClass =
      activities.length === 0 && this.props.section === 'activities'
        ? 'quest-section empty-activities'
        : 'quest-section'
    const errorCount = getErrorCount(error)

    return (
      <div
        className={`quest-body-wrapper ${
          this.props.section === 'questhistory' ? 'questhistory' : ''
        }`}
      >
        {quest && analytics && (
          <StudentStats
            stats={analytics}
            multipleVersionsExist={quest.current_version > 1}
          />
        )}
        {this.props.isEditingQuest &&
          this.presenceChannel &&
          Object.keys(
            filterCurrentUserFromMembers(
              this.presenceChannel.members,
              this.props.user.id
            )
          ).length > 0 && (
            <MultipleEditorsInfo
              channel={this.presenceChannel}
              newEditors={this.state.newEditors}
            />
          )}
        <div className="qm-view quest-body one">
          <div className="quest-section-header">
            <Display style={{ display: 'inline-block' }}>
              {sectionHeader}
            </Display>
            {displayStartEdit && (
              <div className="edit" onClick={this.onEditClickBound} />
            )}
            {displayFinishEdit && !this.props.isUploadingNote && (
              <div className="edit-quest-buttons">
                <div
                  className={`button save save-quest edit btn-primary-small ${
                    isSavingQuest ? 'disabled' : ''
                  }`}
                  onClick={this.onSaveEditClickBound}
                >
                  {isSavingQuest ? 'Saving...' : save}
                </div>
                <div
                  className={`button cancel btn-secondary-small ${
                    isSavingQuest ? 'disabled' : ''
                  }`}
                  onClick={this.onCancelEditClickBound}
                >
                  {cancel}
                </div>
                {error && (
                  <ButtonErrorText style={{ marginLeft: '20px', top: '34px' }}>
                    {`Oops! ${
                      errorCount > 1
                        ? errorCount + ' errors found.'
                        : '1 error found.'
                    }`}
                  </ButtonErrorText>
                )}
              </div>
            )}
            {/* Added the activities conditional below because completness/incompleteness doesn't display if there are no activities */}
            {displayCompleteness && activities.length > 0 && (
              <div
                className={
                  isSectionComplete
                    ? 'completeness complete'
                    : 'completeness incomplete'
                }
              >
                <span>{isSectionComplete ? complete : incomplete}</span>
              </div>
            )}
          </div>
          <div className="line" />
          <div className={questSectionClass}>{section}</div>
          {displayFinishEdit &&
            !this.props.isUploadingNote &&
            this.props.section !== 'otherinformation' && (
              <div className="edit-quest-buttons bottom">
                <div
                  onClick={this.onSaveEditClickBound}
                  className={`button save save-quest edit btn-primary-small ${
                    isSavingQuest ? 'disabled' : ''
                  }`}
                >
                  {isSavingQuest ? 'Saving...' : save}
                </div>
                <div
                  className={`button cancel btn-secondary-small ${
                    isSavingQuest ? 'disabled' : ''
                  }`}
                  onClick={this.onCancelEditClickBound}
                >
                  {cancel}
                </div>
                {displayDeleteQuest && !quest.published_compiled_quest && (
                  <div
                    className="button delete btn-destructive-small"
                    onClick={this.onDeleteQuestClickBound}
                  >
                    Delete Quest...
                  </div>
                )}
                <div id="placeholder" />
                {error && (
                  <ButtonErrorText style={{ marginLeft: '20px' }}>
                    {`Oops! ${
                      errorCount > 1
                        ? errorCount + ' errors found.'
                        : '1 error found.'
                    }`}
                  </ButtonErrorText>
                )}
              </div>
            )}
        </div>
        {hideQuestComments(this.props.section, this.props.activityId) ? null : (
          <Comments />
        )}
        <Modal ref="editQuestErrorModal" className="edit-quest-error-modal">
          <div className="modal-dialog" id="errorModal">
            <div className="close" onClick={this.onCloseModalClickBound} />
            <ul className="error-list">
              <li>{nameCantBeBlank}</li>
            </ul>
          </div>
        </Modal>
        <ModalComponent
          ref="deleteQuestModal"
          quest={quest}
          klass="review-modal modal"
          modalId="deleteQuestModal"
          headingKlass="modal-heading warning no-cap"
          headingText={getTruncatedString({
            val: `Delete "${quest.name}"`,
            len: 93,
            appendClosingQuote: true
          })}
          bodyText={`You're about to delete this quest, which will remove it entirely from QuestMaker and cannot be undone.
          Are you sure you want to proceed?`}
          primaryButtonText={'Yes, Delete'}
          secondaryButtonText={'Cancel, Keep Quest'}
          primaryButtonAction={this.onActualDeleteQuestClickBound}
          secondaryButtonAction={this.hideModalBound}
          primaryButtonDestructiveClass
        />
        <ModalComponent
          ref="multipleEditorsWarningModal"
          klass="modal multiple-editors-modal"
          modalId="multipleEditorsWarningModal"
          headingKlass="modal-heading"
          logoKlass="logo multiple-editors"
          headingText="Edit in Progress"
          bodyText={this.state.presenceChannelModalMessage}
          primaryButtonText="Cancel"
          secondaryButtonText="Edit Anyway"
          primaryButtonAction={this.cancelMultipleUsersEditBound}
          secondaryButtonAction={this.confirmMultipleUsersEditBound}
          setRawHtmlInBody
          handleNonButtonCancelAction={this.cancelMultipleUsersEditBound}
        />
      </div>
    )
  }

  confirmMultipleUsersEdit() {
    const { quest, section, dispatch } = this.props

    let data = {
      action: 'update',
      section: section,
      quest: {
        id: quest.id,
        name: quest.name
      }
    }
    dispatch(postLoggingInfo('quest_multiple_editors', data))
    this.onActualEditClick()
  }

  cancelMultipleUsersEdit() {
    const { quest, section, dispatch } = this.props

    if (window.oeQMQuestPusherInstance) {
      unsubscribeFromAllChannelsWithPrefix(
        window.oeQMQuestPusherInstance,
        'presence'
      )
    }

    let data = {
      action: 'cancel',
      section: section,
      quest: {
        id: quest.id,
        name: quest.name
      }
    }

    dispatch(postLoggingInfo('quest_multiple_editors', data))
    this.hideModal()
  }

  editorAdded(data) {
    this.setState(prevState => ({
      newEditors: prevState.newEditors.concat({
        id: JSON.stringify(data.id),
        name: data.info.name
      })
    }))
  }

  onEditClick() {
    if (!hasNeededPusherConnection(window.oeQMQuestPusherInstance)) {
      return this.onActualEditClick()
    }
    this.presenceChannel = window.oeQMQuestPusherInstance.subscribe(
      `presence-quest-${this.props.quest.id}`
    )
    this.presenceChannel.bind(
      'pusher:subscription_succeeded',
      this.checkMultipleEditorsBound
    )
    this.presenceChannel.bind(
      'pusher:subscription_failed',
      this.onActualEditClickBound
    )
    this.presenceChannel.bind('client-edit', this.editorAddedBound)
  }

  checkMultipleEditors() {
    // check if anyone else is subscribed to this channel
    if (
      Object.keys(this.presenceChannel.members.members).length > 0 &&
      Object.keys(this.presenceChannel.members.members).some(
        m => JSON.parse(m) !== this.props.user.id
      )
    ) {
      this.setState(() => ({
        presenceChannelModalMessage: formatModalWarningMessageProp(
          this.presenceChannel.members,
          this.props.user.id
        )
      }))
      this.multipleEditorsWarningModal.show()
    } else {
      this.props.dispatch(startEditQuest())
    }
  }

  onActualEditClick() {
    const { dispatch } = this.props
    dispatch(startEditQuest())
    if (this.presenceChannel) {
      this.presenceChannel.trigger(
        'client-edit',
        this.presenceChannel.members.me
      )
    }
    this.multipleEditorsWarningModal.hide()
  }

  onCancelEditClick() {
    if (window.oeQMQuestPusherInstance) {
      unsubscribeFromAllChannelsWithPrefix(
        window.oeQMQuestPusherInstance,
        'presence'
      )
    }
    this.props.dispatch(cancelEditQuest())
    this.setState({
      quest: this.props.quest,
      notes: this.props.notes[0]
        ? {
            file: this.props.notes[0],
            description: this.props.notes[0].description
          }
        : ''
    })
  }

  async onSaveEditClick() {
    const { quest } = this.state
    const drivingQuestionError =
      quest.driving_question && quest.driving_question.length > 255
    const learnerGoalError =
      quest.learner_goal && quest.learner_goal.length > 255
    const { intl } = this.context
    const alertMessage = intl.formatMessage(alertMessages.unusualMaterialsLimit)
    if (quest.unusual_materials && quest.unusual_materials.length > 1000) {
      window.alert(alertMessage)
    } else if (!quest.name) {
      this.editQuestErrorModal.show()
    } else if (
      drivingQuestionError ||
      learnerGoalError ||
      contentWarningsSelectedButNoValues(quest.content_warnings)
    ) {
      // stringifying this error to simulate server response, to play nice with existing functions
      this.props.dispatch(
        editQuestDetailsFailure(
          JSON.stringify({
            errors: {
              driving_question: drivingQuestionError
                ? ['length error']
                : undefined,
              learner_goal: learnerGoalError ? ['length error'] : undefined,
              content_warnings: contentWarningsSelectedButNoValues(
                quest.content_warnings
              )
                ? ['content warnings required']
                : undefined
            }
          })
        )
      )
    } else {
      if (this.state.notes) {
        // If an update to existing note
        if (this.props.notes[0] && this.props.notes[0].id) {
          await this.props.dispatch(
            editQuestMentorNote(
              this.props.quest.id,
              this.state.notes,
              this.props.notes[0].id
            )
          )
        } else {
          // If a new note
          await this.props.dispatch(
            createQuestMentorNote(this.props.quest.id, this.state.notes)
          )
        }
      }
      this.props.dispatch(editQuestDetails(quest))
      if (window.oeQMQuestPusherInstance) {
        unsubscribeFromAllChannelsWithPrefix(
          window.oeQMQuestPusherInstance,
          'presence'
        )
      }
    }
  }

  handleChange(event) {
    this.setState({
      quest: { ...this.state.quest, [event.target.id]: event.target.value }
    })
  }

  handleNotesUpload(file) {
    this.setState({
      notes: {
        ...this.state.notes,
        file: file
      }
    })
  }

  handleNotesUploadCancel() {
    this.setState({
      notes: this.props.notes[0]
        ? {
            file: this.props.notes[0],
            description: this.props.notes[0].description
          }
        : ''
    })
  }

  handleNotesDescriptionChange(description) {
    this.setState({
      notes: {
        ...this.state.notes,
        description: description
      }
    })
  }

  handleDeleteNote(noteId) {
    this.props.dispatch(deleteNote(this.props.quest.id, noteId))
    this.setState({ notes: '' })
  }

  onCloseModalClick() {
    this.editQuestErrorModal.hide()
  }

  onDeleteQuestClick() {
    this.deleteQuestModal.show()
  }

  async onActualDeleteQuestClick() {
    const { dispatch, user } = this.props
    await dispatch(deleteQuest(this.props.quest.id))
    await this.deleteQuestModal.hide()
    dispatch(push(getDefaultRoute(user.organization_roles)))
  }

  hideModal() {
    this.deleteQuestModal.hide()
    this.multipleEditorsWarningModal.hide()
  }
}

Body.propTypes = {
  quest: PropTypes.object.isRequired,
  section: PropTypes.string.isRequired,
  subsection: PropTypes.string,
  activityId: PropTypes.number,
  user: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  notes: PropTypes.array,
  isUploadingNote: PropTypes.bool.isRequired,
  isEditingQuest: PropTypes.bool.isRequired,
  tags: PropTypes.array.isRequired,
  quests: PropTypes.array.isRequired,
  organization: PropTypes.object.isRequired,
  topics: PropTypes.array.isRequired,
  handleAssignClick: PropTypes.func.isRequired,
  analytics: PropTypes.object,
  topicSearchResults: PropTypes.array,
  isSearchingTopics: PropTypes.bool,
  isSavingQuest: PropTypes.bool.isRequired,
  error: PropTypes.object,
  activities: PropTypes.array.isRequired
}

Body.contextTypes = {
  intl: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
  section: state.quest.section,
  subsection: state.quest.subsection,
  activityId: state.quest.activityId,
  user: state.user.user,
  notes: state.quest.notes,
  isUploadingNote: state.quest.isUploadingNote,
  isEditingQuest: state.quest.isEditingQuest,
  tags: state.tags.items,
  quests: state.quests.items,
  organization: state.organization,
  topics: state.quest.topics,
  analytics: state.quest.analytics,
  topicSearchResults: state.topics.topicSearchResults,
  isSearchingTopics: state.topics.isSearching,
  isSavingQuest: state.quest.isSavingQuest,
  error: state.quest.error ? parseErrors(state.quest.error) : null,
  activities: state.quest.activities
})

export default connect(mapStateToProps)(Body)
export { Body as BodyDisconnected } // pure component - used in tests



// WEBPACK FOOTER //
// ./src/components/quest/Body.js